export var flipH = 'wLG-S';
export var navFocusSensor = 'RBBCz';
export var navFocusTarget = 'kZpxW';
export var shadow = 'B50Bs';